import { render, staticRenderFns } from "./Knee.vue?vue&type=template&id=914bbab8&scoped=true"
import script from "./Knee.vue?vue&type=script&lang=js"
export * from "./Knee.vue?vue&type=script&lang=js"
import style0 from "./Knee.vue?vue&type=style&index=0&id=914bbab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "914bbab8",
  null
  
)

export default component.exports